import { Link } from 'react-router-dom';
import { useLang } from '../i18n/LanguageContext';
import styles from './LangToggle.module.css';

// Compact EN | DE switch rendered as real, crawlable <Link>s.
// The current language is plain text (highlighted); the other is a link to
// the equivalent URL in that language. Works without JS (server-rendered HTML
// at /de already has lang=de and the toggle points at the English URL).
export default function LangToggle() {
  const { lang, otherLangPath } = useLang();

  if (lang === 'de') {
    return (
      <span className={styles.toggle} aria-label="Sprache wählen">
        <Link to="/de" className={styles.inactive} aria-current="true">
          DE
        </Link>
        <span className={styles.sep} aria-hidden="true">|</span>
        <Link to={otherLangPath} className={styles.active}>EN</Link>
      </span>
    );
  }

  return (
    <span className={styles.toggle} aria-label="Choose language">
      <Link to={otherLangPath} className={styles.active}>DE</Link>
      <span className={styles.sep} aria-hidden="true">|</span>
      <Link to="/" className={styles.inactive} aria-current="true">
        EN
      </Link>
    </span>
  );
}
